import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { setToggleSidebar } from '@app/core/store/actions';
import { Store } from '@ngrx/store';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subscription } from 'rxjs';

import { AlertsComponent } from '../alerts/alerts.component';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, HeaderComponent, AlertsComponent, SidebarComponent],
  standalone: true,
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  currentRoute = '';
  routerEvents!: Subscription;

  roles = this.permissionsService.getPermissions();

  constructor(
    private readonly router: Router,
    private readonly permissionsService: NgxPermissionsService,
    private readonly store: Store
  ) {}

  ngOnInit(): void {
    this.routerEvents = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) this.currentRoute = event.url;
    });
  }

  ngOnDestroy(): void {
    if (this.routerEvents) this.routerEvents.unsubscribe();
  }

  toggleSidebar() {
    this.store.dispatch(setToggleSidebar());
  }
}
